define.alias("ember-math-helpers/helpers/log10", "settings/helpers/log10");